<template>
  <v-expansion-panels  multiple variant="accordion" class="">
    <v-expansion-panel
        style="border-radius: 0"
        v-for="(item,i) in items"
        :key="i"
        @click="setCurrentItemUnset(item);"

    >
      <v-divider></v-divider>
      <v-expansion-panel-title
          @contextmenu.prevent="setCurrentItemUnset(item); isLocked || show($event)"
      >
        <template v-slot:default="{ expanded }">
          <TreeLoadHeader :item="item" :open="expanded"/>
        </template>
      </v-expansion-panel-title>
      <v-expansion-panel-text>
        <v-row>
          <v-col>
            <TreeLoad :item="item"/>
          </v-col>
        </v-row>
      </v-expansion-panel-text>
    </v-expansion-panel>
    <TableActionMenu
      @update:show-menu="showMenu = $event"
      :show-menu="showMenu" :x="x" :y="y"
                     :add-button="false"
                     @action="deleteItem(currentItem.id)"
    />
  </v-expansion-panels>

</template>
<script>
import TreeLoad from '@/components/loads/TreeLoad.vue'
import {mapActions, mapGetters, mapState} from "vuex";
import TreeLoadHeader from '@/components/loads/TreeLoadHeader.vue';
import TableActionMenu from "@/components/common/TableActionMenu.vue";
import ShowActionMenuMixin from '@/mixins/ShowActionMenuMixin.vue';


export default {
  name: 'TreeLoads',
  components: {TreeLoadHeader, TreeLoad, TableActionMenu},
  mixins: [ShowActionMenuMixin],
  props: {},
  computed: {
    ...mapState('treeLoads', {
      items: state => state.items,
      currentItem: state => state.currentItem,
      writeLoading: state => state.writeLoading,
    }),
    ...mapGetters("stabSchematisation", {
      isLocked: "isLockedCurrent",
    }),
  },
  methods: {
    ...mapActions('treeLoads', {
          setCurrentItem: "setCurrentItem",
          deleteItem: "deleteItem",
        }
    ),
    ...mapActions('uniformLoads', {
          setCurrentItemUniform: "setCurrentItem",
        }
    ),
    setCurrentItemUnset(item) {
      this.setCurrentItem(item)
      this.setCurrentItemUniform(null)
    }
  }

}
</script>
